import { render, staticRenderFns } from "./PagePerformanceReviewEdit.vue?vue&type=template&id=5c1fd5a2&"
import script from "./PagePerformanceReviewEdit.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports